import React, { useState } from 'react';

import { CircularProgress } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import ConfirmationModal from '../../components/common/ConfirmationModal';
import UserService from '../../services/user.service';

const ResendInvitationModal = ({ open, onClose, user, onResendSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const userService = new UserService();

  const handleResendInvitation = async () => {
    if (!user || !user.id) return;

    try {
      setIsSubmitting(true);

      await userService.resendInvitation(user.id, user);

      enqueueSnackbar('Invitation email resent successfully', { variant: 'success' });

      if (onResendSuccess) {
        onResendSuccess();
      }

      onClose();
    } catch (error) {
      console.error('Error resending invitation:', error);
      enqueueSnackbar(error.message || 'Failed to resend invitation', { variant: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const confirmText = isSubmitting ? (
    <>
      <CircularProgress size={20} color="inherit" style={{ marginRight: 8 }} />
      Sending...
    </>
  ) : (
    'Resend Invitation'
  );

  return (
    <ConfirmationModal
      style={{ maxWidth: '600px' }}
      open={open}
      onCancel={onClose}
      onConfirm={handleResendInvitation}
      title="Resend Invitation"
      message={`Are you sure you want to resend the invitation email to ${user?.name} (${user?.email})?`}
      confirmText={confirmText}
      cancelText="Cancel"
    />
  );
};

export default ResendInvitationModal;
